<template>
  <div class="stage">
    <Filters :options="stageOptions" :query-key="FILTER_KEY" heading />
    <div class="events">
      <EventCard
        v-for="event in selectedStageData.events"
        :key="event.id"
        :event="event"
        :color="selectedStageData.place_color"
        :place="selectedStageData.place_name"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { LineUpStage } from '@/service/__generated-api'

const props = defineProps<{
  stages: LineUpStage[]
}>()

const route = useRoute()

const FILTER_KEY = 'stage'
const selectedStage = computed(
  () => route.query[FILTER_KEY] ?? props.stages[0].place_name
)

const stageOptions = computed(() =>
  props.stages.map(({ place_name }, index) => ({
    label: place_name,
    value: !index ? undefined : place_name
  }))
)

const selectedStageData = computed(
  () =>
    props.stages.find(({ place_name }) => place_name === selectedStage.value) ??
    props.stages[0]
)

const date = computed(() => route.query.date)
watch(date, () => {
  delete route.query[FILTER_KEY]
})
</script>

<style scoped lang="scss">
.stage {
  margin-top: rem(64px);
}

.events {
  display: flex;
  flex-direction: column;
  gap: rem(8px);
}
</style>
